import type { NavigationCallToAction } from '@snapchat/mw-contentful-schema';
import type React from 'react';
import { useLocation } from 'react-router-dom';

import { CallToAction } from '../CallToAction';
import { DisplayMode } from '../CallToAction/types';
import { useExperiment } from '../Experiment';

interface Props extends NavigationCallToAction {
  displayMode?: DisplayMode;
}

export const NavigationCta: React.FC<Props> = props => {
  const { checkCriteria } = useExperiment();
  const location = useLocation();
  const { displayMode = DisplayMode.DesktopHeader } = props;

  // Get current slug from pathname (remove leading slash)
  const currentSlug = location.pathname.substring(1) || 'home';

  // Only render if the displayMode prop matches the Contentful settings
  const matchesDisplayMode = props.displayModes?.includes(displayMode);
  // This is mis-named, and the model should be "showCriteria". :facepalm:.
  const shouldShow = !props.hideCriteria || checkCriteria(props.hideCriteria);
  // Check if current slug matches any of the hideForSlugs
  const isHiddenForCurrentSlug = props.hideForSlugs?.some((slug: string) => currentSlug === slug);

  if (!matchesDisplayMode || !shouldShow || isHiddenForCurrentSlug) return null;
  return props.callToAction ? <CallToAction {...props.callToAction} /> : null;
};
